export enum HouseholdClaimActionTypes {
    CLAIM_LOAD_SUMMARIES = "@householdclaim/LOAD_SUMMARIES",
    CLAIM_FILL_SUMMARIES = "@householdclaim/FILL_SUMMARIES",
    CLAIM_ERROR_SUMMARIES = "@householdclaim/ERROR_SUMMARIES",
}
